var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-content has-text-centered" }, [
      _c("h1", { staticClass: "title is-3" }, [_vm._v("Eliminar documento")]),
      _vm._v(" "),
      _c("h2", { staticClass: "subtitle is-5" }, [
        _vm._v("¿Está seguro que desea eliminar " + _vm._s(_vm.getName) + "?"),
      ]),
      _vm._v(" "),
      _vm.file
        ? _c("p", { staticClass: "is-size-6 has-text-info" }, [
            _c("i", { staticClass: "far fa-fw fa-lg", class: _vm.getIcon }),
            _vm._v(" " + _vm._s(_vm.file.nombre)),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "card-footer-item has-text-danger has-text-weight-bold is-uppercase",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.deleteDocumento.apply(null, arguments)
            },
          },
        },
        [_vm._v("Eliminar")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }